// @core/api/endpoints/task/list_templates.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TaskListTemplatesResponse,
} from '../../../types/task';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/task';

/**
 * List templates
 * Returns all task templates available in the product for use when creating new tasks.
 */
export async function ListTemplates(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<TaskListTemplatesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/task-templates`;
  const requestOptions = options;
  return client.get<TaskListTemplatesResponse>(requestPath, { ...requestOptions, params });
}
